import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "overlay", "buttonLabel"]
  static classes = ["collapsed"]
  static values = {
    expanded: { type: Boolean, default: false },
    expandedText: String,
    collapsedText: String
  }

  connect() {
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.render()
  }

  render() {
    this.contentTarget.classList.toggle(this.collapsedClass, !this.expandedValue)

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle("hidden", this.expandedValue)
    }

    if (this.hasButtonLabelTarget) {
      this.buttonLabelTarget.textContent = this.expandedValue ? this.expandedTextValue : this.collapsedTextValue
    }

    this.element.setAttribute("aria-expanded", this.expandedValue.toString())
  }
}
